import {announce as $e5a8c0eef40ba0e6$re_export$announce, clearAnnouncer as $e5a8c0eef40ba0e6$re_export$clearAnnouncer, destroyAnnouncer as $e5a8c0eef40ba0e6$re_export$destroyAnnouncer} from "react-aria/private/live-announcer/LiveAnnouncer";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


export {$e5a8c0eef40ba0e6$re_export$announce as announce, $e5a8c0eef40ba0e6$re_export$clearAnnouncer as clearAnnouncer, $e5a8c0eef40ba0e6$re_export$destroyAnnouncer as destroyAnnouncer};
//# sourceMappingURL=module.js.map
